import { useToast } from 'primevue/usetoast';

export default function useToaster() {
  const toast = useToast();

  const add = ({ severity, summary, detail, life = 3000 }) => {
    toast.add({ severity, summary, detail, life });
  };
  const success = ({ summary = 'Success', detail, life = 3000 }) => {
    add({ severity: 'success', summary, detail, life });
  };

  const info = ({ summary = 'Info', detail, life = 3000 }) => {
    add({ severity: 'info', summary, detail, life });
  };

  const warn = ({ summary = 'Info', detail, life = 3000 }) => {
    add({ severity: 'warn', summary, detail, life });
  };

  const error = ({ summary = 'Error', detail, life = 3000 }) => {
    add({ severity: 'error', summary, detail, life });
  };

  return {
    add,
    success,
    info,
    warn,
    error
  };
}
